import Base from "@/api/Base";

export default class Change extends Base
{
	setPasswordOld (v)
	{
		this.data.passwordOld = v;
		return this;
	}

	setPasswordNew (v)
	{
		this.data.passwordNew = v;
		return this;
	}

	getMethod ()
	{
		return 'POST';
	}

	getUrl ()
	{
		return '/auth/passwort';
	}
}
